import projectStatusTypesApi from '@/api/projectStatusTypes';

const state = {
  projectStatusTypes: [],
};


export const getters = {

  formattedProjectStatusTypes: state =>
    state.projectStatusTypes.map(type => ({
      label: type.name,
      value: type.typeGuid,
    })),

  formattedProjectStatus: state => (typeGuid) => {
    let name = '';
    for (let i = 0; i < state.projectStatusTypes.length; i += 1) {
      if (typeGuid === state.projectStatusTypes[i].typeGuid) {
        // eslint-disable-next-line
        name = state.projectStatusTypes[i].name;
      }
    }
    return name;
  },
};

export const actions = {
  getList({ commit }) {
    projectStatusTypesApi.getProjectStatusTypes().then((data) => {
      commit('projectStatusTypes', data.projectStatusTypes);
    });
  },
};

export const mutations = {
  projectStatusTypes(state, payload) {
    state.projectStatusTypes = payload;
  },
};


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
